import { useEffect } from "react";
import { EventsListPublic } from "../../components/public/EventsListPublic";
import { EventsCalendar } from "../../components/public/EventsCalendar";
import { branding, organization } from "../../config";

export default function EventsPublic() {
  useEffect(() => {
    document.title = `Events - ${organization.name}`;
  }, []);

  return (
    <>
      {/* Upcoming Events Section */}
      <section className="container my-5" style={{ maxWidth: "1200px" }}>
        <div className="text-center mb-4">
          <h2
            style={{
              color: branding.primaryColor,
              fontWeight: "700",
              letterSpacing: "0.5px",
              // textTransform: "uppercase",
            }}
          >
            Upcoming Events
          </h2>
          {/* <p
            className="text-muted"
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              color: "#6c757d",
              fontSize: "1.05rem",
              lineHeight: "1.6",
            }}
          >
            Join us for our upcoming community events. From educational talks to
            community meetings, you're invited to be part of our mission.
          </p> */}
        </div>

        <EventsListPublic />
      </section>

      {/* Calendar Section */}
      <section className="container my-2 py-2" style={{ maxWidth: "1200px" }}>
        <div className="text-center mb-4">
          <h2
            style={{
              color: branding.primaryColor,
              fontWeight: "700",
              letterSpacing: "0.5px",
              // textTransform: "uppercase",
            }}
          >
            Event Calendar
          </h2>
        </div>
        
        <EventsCalendar />
      </section>
    </>
  );
}
